export class RemovalPivot {
  pivotKey: string;
  total: number;
  unscheduledRemovalCount: number;
  averageTimeSinceInstall: number;
  badFromStockRate: number;
  badFromStockCount: number;
  noFaultFoundRate: number;
  extremeInfantMortalityRate: number;
  extremeInfantMortalityCount: number;
  totalM2Count: number;
  significantEventCount: number;
  totalM2Minutes: number;
  averageM2Minutes: number;
  totalM2Cost: number;
  averageM2Cost: number;
}
